import React from "react";

import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export interface State extends SnackbarOrigin {
  duration: number;
}

interface ParamsAlerts {
  tipoAlerta: "error" | "warning" | "info" | "success";
  show: boolean;
  menssage: string;
  handleClose():void;
}

export default function Alerts(params: ParamsAlerts) {
  const { tipoAlerta, show, menssage, handleClose } = params;
  const [state, setState] = React.useState<State>({
    vertical: "bottom",
    horizontal: "right",
    duration: 5000
  });
  const { vertical, horizontal, duration } = state;


  return (
    <Snackbar
      id={'snackbar-alert'}
      open={show}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
      disableWindowBlurListener={true}
    >
      <Alert onClose={handleClose} severity={tipoAlerta}>
        <div>{menssage}</div>
      </Alert>
    </Snackbar>
  );
}
